import { Trans, useTranslation } from 'react-i18next'

import { Text, VStack } from '@enechain/ecloud-designsystem'

import { ConfirmDialog } from '~/components/common/ConfirmDialog'
import type { IntradayBulkDelete } from '~/pages/IntradayBidding/hooks/useIntradayBulkDelete'

type Props = {
  bulkDelete: Pick<
    IntradayBulkDelete,
    'confirmScope' | 'isSubmitting' | 'confirm' | 'cancel'
  >
}

/**
 * 入札を全削除の確認ダイアログ (AC-BIN-138)。 件数は開いた時点で固定した対象の件数 (強調)。
 * 表示していない下書きが 1 件以上ある時だけ、 対象外の件数を添える (AC-BIN-009 の提出確認と同じ文言)。
 * 送信中は「全削除」 を loading にして二重に押させない。
 */
export const IntradayBulkDeleteConfirmDialog = ({
  bulkDelete,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const { confirmScope, isSubmitting, confirm, cancel } = bulkDelete
  return (
    <ConfirmDialog
      body={
        <VStack align="stretch" gap={3}>
          <Text>
            <Trans
              components={{ strong: <Text as="strong" /> }}
              i18nKey="page:biddingIntraday.bulkDelete.confirm.body"
              values={{ count: confirmScope?.targets.length ?? 0 }}
            />
          </Text>
          {confirmScope !== undefined && confirmScope.hiddenCount > 0 && (
            <Text textStyle="captionNormal" color="Text.midEmphasis">
              {t('page:biddingIntraday.bulkDelete.confirm.excluded', {
                count: confirmScope.hiddenCount,
              })}
            </Text>
          )}
        </VStack>
      }
      confirmLabel={t('page:biddingIntraday.bulkDelete.confirm.confirm')}
      destructive
      isLoading={isSubmitting}
      isOpen={confirmScope !== undefined}
      onCancel={cancel}
      onConfirm={() => {
        void confirm()
      }}
      title={t('page:biddingIntraday.bulkDelete.confirm.title')}
    />
  )
}
